import { Title, Stack, Divider } from "@mantine/core";
import { Comunidad, Edad, Etnia, Genero } from ".";
import { TStaffSurveyStatus } from "../../../types/TStaffSurveyStatus";

type Props = {
  form: any;
  staff_survey: TStaffSurveyStatus;
};

export const InformacionPersonal = ({ form, staff_survey }: Props) => {
  return (
    <Stack spacing="lg">
      <Title order={3}>Información Personal</Title>
      <Genero form={form} staff_survey={staff_survey} />
      {staff_survey.flag_002 && <Edad form={form} />}
      {staff_survey.flag_003 && <Comunidad form={form} />}
      {staff_survey.flag_004 && <Etnia form={form} />}
    </Stack>
  );
};
